import bombDefused from '../../content/roundEnds/bomb_defused.svg';
import bombExploded from '../../content/roundEnds/bomb_exploded.svg';
import ctWin from '../../content/roundEnds/ct_win.svg';
import tWin from '../../content/roundEnds/t_win.svg';
import stopwatch from '../../content/roundEnds/stopwatch.svg';
import emptyHistory from '../../content/roundEnds/emptyHistory.svg';

// Side colours of the round-history strip, also the Swing tab's T/CT fills.
export const CT_COLOR = '#5bc0de';
export const T_COLOR = '#f0ad4e';

// Win-type icon for a round-end reason (white SVGs, tinted through a CSS mask).
export const roundEndIcon = (reason: string): string => {
    switch (reason) {
        case 'TargetBombed': return bombExploded;
        case 'BombDefused': return bombDefused;
        case 'TerroristsWin': return tWin;
        case 'CTsWin': return ctWin;
        case 'TargetSaved':
        case 'RoundDraw': return stopwatch; // time ran out = CT win
        default: return emptyHistory;
    }
};
